import isEqual from 'lodash-es/isEqual'

function getInitDataStableValue(prevValue, value) {
  return isEqual(prevValue, value) ? prevValue : value
}

// The app router is built from the sections, so a refetch keeps the unchanged
// ones by reference: a rebuilt router keeps a mounted page's stale blocker
export function getRefetchedInitData(prevInitData, initData) {
  return prevInitData
    ? {
        ...initData,
        sections: getInitDataStableValue(
          prevInitData.sections,
          initData.sections
        ),
        ui_sections: getInitDataStableValue(
          prevInitData.ui_sections,
          initData.ui_sections
        ),
      }
    : initData
}
